import { AccountTree, Close } from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";

interface IBatchHeaderActions {
    setOpen:(set: boolean) => void;
}

export const BatchHeaderActions : React.FC<IBatchHeaderActions> = ({
    setOpen
}) => {
    return (
        <>
            <Box
                width="40px"
                height="40px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    backgroundColor: "#22638D1A"
                }}
            >
                <AccountTree 
                    sx={{
                        color: "#22638D"
                    }}
                />
            </Box>
            <Box
                width="28px"
                height="28px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                onClick={() => {
                    setOpen(false);
                }}
                sx={{
                    cursor: "pointer",
                    ":hover": {
                        backgroundColor: "#22638D1A",
                        borderRadius: "50%",
                        color: "#22638D"
                    }
                }}
            >   
                <Close />
            </Box>
        </>
    )
}